/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Ingredients_AllInputs */

const en_recipe_ingredients_all = /** @type {(inputs: Recipe_Ingredients_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All together`)
};

const de_recipe_ingredients_all = /** @type {(inputs: Recipe_Ingredients_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

/**
* | output |
* | --- |
* | "All together" |
*
* @param {Recipe_Ingredients_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_ingredients_all = /** @type {((inputs?: Recipe_Ingredients_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Ingredients_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_ingredients_all(inputs)
	return en_recipe_ingredients_all(inputs)
});